import { formatDateEndOfDay } from "helpers/formatDate";
import { IAtleta } from "interfaces/atleta";
import { formFieldAtleta } from "./fieldAtleta";
import { numbersOnly } from "helpers/utils";

const {
  nome,
  apelido,
  cpf,
  rg,
  dataNascimento,
  equipe,
  email,
  celPhone,
  telefone,
  nomeEmergencia,
  celPhoneEmergencia,
  parentesco,
  planoSaude,
  sexo,
  cep,
  endereco,
  numero,
  bairro,
  cidade,
  uf,
  complemento,
} = formFieldAtleta;

const initialValuesEditAtleta = (atleta: IAtleta) => {
  return {
    [nome.name]: atleta.nome,
    [apelido.name]: atleta.apelido,
    [cpf.name]: atleta.cpf,
    [rg.name]: atleta.rg,
    [dataNascimento.name]: formatDateEndOfDay(
      atleta.dataNascimento,
      "yyyy-MM-dd"
    ),
    [equipe.name]: atleta.equipe,
    [email.name]: atleta.email,
    [celPhone.name]: numbersOnly(atleta.celPhone),
    [telefone.name]: numbersOnly(atleta.telefone),
    [nomeEmergencia.name]: atleta.nomeEmergencia,
    [celPhoneEmergencia.name]: numbersOnly(atleta.celPhoneEmergencia),
    [parentesco.name]: atleta.parentesco,
    [planoSaude.name]: atleta.planoSaude,
    [sexo.name]: atleta.sexo.tipo,
    [cep.name]: atleta.enderecos[0].cep,
    [endereco.name]: atleta.enderecos[0].endereco,
    [numero.name]: atleta.enderecos[0].numero,
    [bairro.name]: atleta.enderecos[0].bairro,
    [cidade.name]: atleta.enderecos[0].cidade,
    [uf.name]: atleta.enderecos[0].uf,
    [complemento.name]: atleta.enderecos[0].complemento,
  };
};

const initialValuesAtleta = {
  [nome.name]: "",
  [apelido.name]: "",
  [cpf.name]: "",
  [rg.name]: "",
  [dataNascimento.name]: "",
  [equipe.name]: "",
  [email.name]: "",
  [celPhone.name]: "",
  [telefone.name]: "",
  [nomeEmergencia.name]: "",
  [celPhoneEmergencia.name]: "",
  [parentesco.name]: "",
  [planoSaude.name]: "",
  [sexo.name]: "",
  [cep.name]: "",
  [endereco.name]: "",
  [numero.name]: "",
  [bairro.name]: "",
  [cidade.name]: "",
  [uf.name]: "",
  [complemento.name]: "",
};

export { initialValuesAtleta, initialValuesEditAtleta };
